module.exports = "/_next/static/images/781fe48830fefec4308280294ef6f110-roxinho-card-with-phone-lg@3x.jpg.webp";